import { OrganizationNames } from "../enums/organization-names.enum";
import { OrganizationContentSettings } from "../models/organization-content-settings.interface";

export const ORGANIZATION_CONTENT_SETTINGS: Partial<
  Record<OrganizationNames, OrganizationContentSettings>
> = {
  [OrganizationNames.Aetna]: {
    reportLogo: "/assets/punch/images/aetna-logo.svg",
    scheduleAppointmentLink: "https://www.theteledentists.com/aetna",
  },
  [OrganizationNames.Teledentists]: {
    reportLogo: "/assets/punch/images/kells-teledentists.svg",
    scheduleAppointmentLink: "https://ai.theteledentistsvideo.com",
    scheduleAppointmentDescription: `
      Schedule a virtual consultation with a remote dentist in your state to go over the report and discuss any questions or needs you may have. Use Service Key “KELLS” when creating an account with The TeleDentists for your discounted consultation.
    `,
  },
  [OrganizationNames.KareMobile]: {
    reportLogo: "/assets/punch/images/kells-kare.svg",
  },
  [OrganizationNames.OralLink]: {
    patientHubLink: "https://patients.orallink.health/",
    scanDisclaimer: `
      <h4>CONSENT FOR DENTAL ASSESSMENTS</h4>
      <p>
          By clicking “Agree”, I, hereby provide consent for <b>Oral Link Pte. Ltd.</b> and its authorized personnel to conduct necessary dental assessments, screening, and any related dental matters.
      </p>
      <p>
          I understand that all medical and dental procedures carry certain risks, including but not limited to discomfort, temporary sensitivity, or unforeseen complications. I accept these risks and agree to follow all post-treatment care instructions provided
          by the dental clinic.
      </p>
      <h4>CONSENT FOR PERSONAL DATA</h4>
      <p>
          In accordance with the Personal Data Protection Act 2012 (PDPA) of Singapore, I consent to <b>Oral Link Pte. Ltd.</b> collecting, using, disclosing, and processing my personal data, including medical and dental records, for the following purposes:
      </p>
      <ol>
          <li>Oral Link is providing a dental scan AI service for the User.</li>
          <li>The provided AI scan is a screening tool and used for providing the user with information about their oral health.</li>
          <li>Oral Link will endeavour to match the users with the closest possible dentist for follow-up treatment.</li>
          <li>Oral Link is not responsible for providing the dental treatment to the users.</li>
          <li>The nature, purpose, potential risks, and alternatives of the assessments and treatment have been or will be explained to the user.</li>
          <li>Any dental procedures involve inherent risks, including but not limited to discomfort, temporary sensitivity, or unforeseen complications.</li>
          <li>The individuals will be responsible for following post-treatment care instructions provided by the clinic.</li>
          <li>Referrals to dental clinic that will provide dental care, treatment, and follow-up services.</li>
          <li>Coordinating and assist to manage appointments.</li>
          <li>Communicating with me regarding my dental clinic options.</li>
          <li>Conducting internal audits, regulatory compliance, and reporting obligations.</li>
          <li>Any other purposes required by law or authorised by me.</li>
      </ol>
      <p>
          I acknowledge that my personal data may or will be disclosed by Oral Link to Oral Link’s affiliates, business partners and/or related companies, which may be sited outside of Singapore, for the above purposes; and I consent to such third party service
          providers or agents of the Company processing my personal data for the above purposes.
      </p>

      <p>
          Apart from what has been stated in this document, I understand that my personal data will be kept confidential and will not be shared with third parties without my consent, except where required by law or regulatory authorities.
      </p>

      <p>
          I am aware that I may request access to or correction of my personal data, or withdraw my consent, by contacting <b>Oral Link at <a href="mailto:info@orallink.health">info@orallink.health</a></b>.
      </p>

      <p>
          By clicking “Agree”, I acknowledge that I am happy to proceed and confirm that I have read, understood, and voluntarily agree to this consent.
      </p>   
    `,
  },
};
